import { LoadSpinnerService } from './../shared/services/load-spinner.service';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoaderInterceptor implements HttpInterceptor {
  /**
   *
   */
  constructor(private loader: LoadSpinnerService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has('ignoreLoader')) {
      return next.handle(req);
    }
    this.loader.showSpinner();
    return next.handle(req).pipe(finalize(() => this.loader.hideSpinner()));
  }
}
